import AppStorage from '@Services/AppStorage';
import { DEFAULT_ERROR_MESSAGE, NOVARTIS_ERROR, NOVARTIS_ERROR_MESSAGE } from './InstitutionConstants';

export function useLastSelectedInstitution() {
  return AppStorage.instance.get('lastSelectedInstitution');
}

const isNovartisErrorMessage = (errorMessage) => {
  return errorMessage === NOVARTIS_ERROR;
};

export function useInstitutionErrorMessage(errorMessage) {
  if (!isNovartisErrorMessage(errorMessage)) {
    return DEFAULT_ERROR_MESSAGE;
  }

  return NOVARTIS_ERROR_MESSAGE;
}
